const lightTheme = {
    main: '#FFFFFF',
    flip: '#000000',
    inverse: '#1A181F',
    alt: '#F4F4F4',
    altWhite: '#FFFFFF',
    textMain: '#000000',
    cover: 'rgba(169, 169, 169, 0.69)',
    formGray: '#F8F8F8',
    textLight: 'rgba(0, 0, 0, 0.40)',
    togglerFill: '#FFFFFF',
    grayText: '#6B6B6B',
    outline: 'rgba(0, 0, 0, 0.10)',
    formShadow:
        '0px 13.658536911010742px 40.975608825683594px 0px rgba(116, 116, 116, 0.25)',
};

export const darkTheme = {
    main: '#151517',
    flip: '#FFFFFF',
    inverse: '#FFFFFF',
    alt: '#201E26',
    altWhite: '#201E26',
    textMain: 'white',
    grayText: '#ACACAC',
    formGray: '#3E3D43',
    textLight: 'rgba(255, 255, 255, 0.40)',
    togglerFill: '#151517',
    outline: 'rgba(255, 255, 255, 0.10)',
    cover: 'rgba(13, 13, 13, 0.69)',
    formShadow:
        '0px 13.658536911010742px 40.975608825683594px 0px rgba(0, 0, 0, 0.62)',
};

export default lightTheme;